export default {
    namespaced: true,
    state: () => ({
        buttons: {
            top: {},
            dailyCheckMenu: {},
            cookingCheckMenu: {},
        },
        selectedManageButton:{}
    }),
    getters: {
        buttons (state) {
            return state.buttons
        },
        top (state) {
            return state.buttons.top
        },
        topButton: (state) => (id) => {
            const button = state.buttons.top.filter(obj => {
                return obj.id == id
            })
            return button.shift()
        },
        dailyCheckButton: (state) => (menuId, subMenuId) => {
            const button = state.buttons.dailyCheckMenu[menuId].filter(obj => {
                return obj.dailyCheckButtonId == subMenuId
            })
            return button.shift()
        },
        cookingCheckButton: (state) => (subMenuId) => {
            const button = state.buttons.cookingCheckMenu.filter(obj => {
                return obj.importantButtonId == subMenuId
            })
            return button.shift()
        },
        selectedManageButtonToName (state) {
            return state.selectedManageButton.to.name
        },
    },
    mutations: {
        setButtons(state, {key, list}) {
            state.buttons[key] = list
        },
        setSelectedManageButton(state, selectedManageButton) {
            state.selectedManageButton = selectedManageButton
        }
    },
    actions: {
        set({ commit }, { key, list }) {
            commit('setButtons', { key, list } )
        },
        setSelectedManageButton({ commit }, selectedManageButton) {
            commit('setSelectedManageButton', selectedManageButton )
        },
    },
}
